import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form } from 'semantic-ui-react'
import CommonValueBuildUpTab from '@commonComponents/commonValueBuildUpTab'
import ValuBuildUpProvider from '@commonComponents/commonValueBuildUpTab/valuBuildUpProvider'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import { useEvent } from '@hooks/useEvent'
import { useTranslation } from '@hooks/useTranslation'
import { itemActions } from '../../reducer/ItemSlice'
import VBUProvider from '@EUForms/VBUProvider'

// import { useCurrentShipmentType, useForm } from '@hooks'
// import { updateLineData } from '../../actions'
// import { ActorContext } from '../partiesTab/Actors/actorProvider'

const ValueBuildUpTab = () => {

  const {buyersList, importersList, sellersList, exportersList } = useSelector(state => state.actorReducer)
  const procedure = useSelector(state => state.headerReducer.headerTab?.procedure)
  const { isDisabled, isImportShipment } = useCurrentShipmentType()
const { saveForm } = useEvent('invoiceTab')
const translate = useTranslation()
const { invoiceUpperHeader, invoiceIdList, invoiceMap } = useSelector(
  (state) => state?.invoiceReducer.invoice
)
const invoiceId = invoiceIdList[0]
const incoTerm = invoiceMap[invoiceId]?.invoiceHeader?.deliveryTerms?.incoTerms
const { updateMerchandiseItem } = itemActions


const dispatch = useDispatch()
const updateFunc = useCallback(
  ({merchandiseId, data}) => {
    dispatch(updateMerchandiseItem({ merchandiseId, data }))
  },
  [updateMerchandiseItem]
)
const saveFunc = useCallback(
  async ({merchandiseId,invoiceId, data}) => {
    await saveForm({ merchandiseMap: { [merchandiseId]: { ...data, invoiceId } } }, false)
  },
  [saveForm, invoiceId]
)

//     const createDutyFunc = useCallback(
//       (...args) => {
//       },
//       []
//     )

//     const deleteDutyFunc = useCallback(
//       (...args) => {
//       },
//       []
//   )

  return (
    <VBUProvider
      updateFunc={updateFunc}
      saveFunc={saveFunc}
      // createDutyFunc={createDutyFunc}
      // deleteDutyFunc={deleteDutyFunc}
    >
      <div className='valueBuildUp formContentareaC88'>
        <Form.Group className='float-container'>
          <CommonValueBuildUpTab
            DropDownReducer='dropDownReducer'
            translate={translate}
            incoTerm={incoTerm}
            invoiceAmount={invoiceUpperHeader?.totalInvoiceAmount}
            isDisabled={isDisabled}
            isNLAPP={true}
            isDMS={true}
            isImportShipment={isImportShipment}
            buyer={buyersList?.length > 0 ? buyersList : importersList}
            seller={sellersList?.length > 0 ? sellersList : exportersList}
            procedure={procedure}
          />
        </Form.Group>
      </div>
    </VBUProvider>
  )
}

export default ValueBuildUpTab